import { useMemo } from 'react';
import { isMarketingEmailAsset } from '../types';
export function useAllowedAssets(assets) {
  return useMemo(() => {
    const allowedAssets = [];
    const disallowedAssets = [];
    assets.forEach(asset => {
      if (isMarketingEmailAsset(asset)) {
        if (asset.metadata['marketing-email'].emailType === 'AUTOMATED_EMAIL') {
          allowedAssets.push(asset);
          return;
        } else {
          disallowedAssets.push(Object.assign({}, asset, {
            skipReason: 'NOT_AUTOMATED_EMAIL'
          }));
          return;
        }
      }
      console.error('Asset type not supported');
    });
    return [allowedAssets, disallowedAssets];
  }, [assets]);
}